var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _vm.history.length === 0 ? _c("custom-result-not-found") : _vm._e(),
      _c(
        "time-line",
        _vm._l(_vm.history, function(item, index) {
          return _c(
            "div",
            { key: `item-index-${index}` },
            [
              _c(
                "time-line-item",
                {
                  staticClass: "custom-time-line rounded",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function() {
                          return [
                            _c("em", {
                              staticClass: "fas fa-file radius color-white"
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "date",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "date-container" }, [
                              _c("div", { staticClass: "font-12" }, [
                                _vm._v("Fecha")
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-bold fulldate"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("date")(item.createdDateTime)
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-12 font-weight-normal hour"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("hour")(item.createdDateTime)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("div", { staticClass: "row py-4 mx-3" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("em", {
                          staticClass: "fas fa-circle mr-2 font-12",
                          style: { color: _vm.resolveColor(item.statusId) }
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-black font-16 font-weight-normal"
                          },
                          [_vm._v(" " + _vm._s(item.statusName) + " ")]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-gray-6 font-14 font-weight-normal"
                        },
                        [_vm._v(" Nombre del Usuario ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "color-black font-16 font-weight-normal"
                        },
                        [_vm._v(" " + _vm._s(item.creatororName) + " ")]
                      )
                    ]),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-gray-6 font-14 font-weight-normal"
                        },
                        [_vm._v(" Nombre del archivo: ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "color-black font-16 font-weight-normal"
                        },
                        [_vm._v(" " + _vm._s(item.filename) + " ")]
                      )
                    ]),
                    item.comment
                      ? _c(
                          "div",
                          {
                            staticClass: "col-md-12 p-2 mt-3 comment__container"
                          },
                          [
                            _c("p", [
                              _c("em", {
                                staticClass:
                                  "fas fa-info-circle color-primary-2"
                              }),
                              _c("b", { staticClass: "ml-2" }, [
                                _vm._v("Comentario")
                              ])
                            ]),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(item.comment))
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("em", { staticClass: "fa fa-clock color-primary-2" }),
      _c("b", { staticClass: "ml-2" }, [_vm._v("Historial de Documentos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }